import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IImageEditor from './IImageEditor';
import IImageEditorInput from './IImageEditorInput';

export class ImageEditorsApi {
    static getImageEditors(): Promise<any> {
        return new Api().get(`/views/imageeditors`);
    }

    static addUser(imageEditor: IImageEditorInput): Promise<any> {
        return new Api().post('/views/imageeditors', imageEditor);
    }

    static getEditImageEditor(id: number): Promise<any> {
        return new Api().get(`/views/imageeditors/${id}/edit`);
    }

    static deleteUser(id: number): Promise<any> {
        return new Api().delete(`/views/imageeditors/${id}`);
    }

    static updateUser(id: number, user: IImageEditorInput): Promise<any> {
        return new Api().put(`/views/imageeditors/${id}`, user);
    }

    static getNewImageEditor() {
        return new Api().get('/views/imageeditors/new');
    }
}

export default ImageEditorsApi;
